import { StyleSheet } from "react-native"
import { colors } from "colors"
import { typography } from "theme"

export const style = StyleSheet.create({
  voucherContainer: {
    flex: 1,
    justifyContent: "space-around",
    height: "100%",
  },
  leftCurved: {
    position: "absolute",
    width: 30,
    height: 30,
    borderRadius: 100,
    backgroundColor: `white`,
    top: 45,
    left: -15,
    zIndex: 1,
  },
  rightCurved: {
    position: "absolute",
    width: 30,
    height: 30,
    borderRadius: 100,
    backgroundColor: `white`,
    top: 45,
    right: -15,
    zIndex: 1,
  },
  voucherContentContainer: {
    borderRadius: 10,
    marginTop: 10,
    padding: 20,
    paddingLeft: 0,
    paddingRight: 0,
    position: "relative",
    borderWidth: 0,
  },
  voucherText: {
    color: colors.black,
    fontFamily: typography.primary.normal,
  },
  contentContainerV: {
    justifyContent: "center",
    width: 180,
    maxWidth: 180,
    marginRight: 15,
    borderRadius: 10,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOpacity: 0.3,
    shadowOffset: { width: 0, height: 0.5 },
    shadowRadius: 4,
    elevation: 2,
  },

  voucherTitleText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 16,
    fontWeight: "bold",
  },
  row: { alignItems: "center", flexDirection: "row", flex: 1, paddingHorizontal: 20, height: 100 },
  expiryText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 11,
    marginBottom: 5,
  },
  image: {
    width: 80,
    height: 80,
    alignSelf: "flex-end",
    borderRadius: 15,
    marginRight: 5,
  },
  dottedLine: {
    marginRight: 10,
    marginVertical: 4,
  },
  countDownContainer: {
    zIndex: 1,
    position: "absolute",
    alignSelf: "center",
    justifyContent: "center",
    fontSize: 20,
    color: "white",
    backgroundColor: "rgba(0,0,0,0.5)",
    padding: 5,
    borderRadius: 5,
    fontWeight: "bold",
  },
  countDown: {
    width: 100,
    height: 100,
    zIndex: 999,
  },
  expiredClaimedImage: {
    width: 140,
    height: 140,
    position: "absolute",
    justifyContent: "center",
    alignSelf: "center",
    zIndex: 999,
    opacity: 0.9,
  },
  expiredClaimedImagev2: {
    width: 100,
    height: 100,
    position: "absolute",
    right: 15,
    bottom: 10,
    zIndex: 999,
    opacity: 0.8,
    borderRadius: 10,
  },
  pointText: {
    fontFamily: typography.primary.normal,
    fontSize: 14,
    width: "100%",
    textAlign: "left",
    marginTop: 5,
  },
})
